import { FC, useEffect, useState } from "react";
import Input from "../Input/Input";
import Button from "../Button/Button";
import { Textarea } from "../Textarea/Textarea";
import { useForm } from "react-hook-form";
import { useFeedbackForm } from "../../hooks/useFeedbackForm";
import { CSSTransition } from "react-transition-group";
import { Spinner } from "../Loader/Loader";
import {
  StyledLoaderWrapper,
  StyledFeedbackform,
  StyledFormGroup,
  StyledFeedbackFormAction,
  StyledActionText,
} from "./feedbackForm.style";

interface IFormData {
  message: string;
  email: string;
  phone: string;
}

interface IFeedbackForm {
  isMobile?: boolean;
}

const FeedbackForm: FC<IFeedbackForm> = (props): JSX.Element => {
  const { isMobile } = props;
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<IFormData>();
  const [feedbackData, setFeedbackData] = useState<IFormData>({
    email: "",
    message: "",
    phone: "",
  });
  const [isShowedActionText, setIsShowedActionText] = useState<boolean>(false);
  const { feedBackFormSuccess, feedBackFormError, isFeedBackFormLoading } =
    useFeedbackForm("feedback", feedbackData);

  useEffect(() => {
    if (feedBackFormSuccess || feedBackFormError) {
      setIsShowedActionText(true);

      setTimeout(() => {
        setIsShowedActionText(false);
      }, 4000);
    }
  }, [feedBackFormSuccess, feedBackFormError]);

  const handlerSubmit = (data: any) => {
    const formData: IFormData = data;
    setFeedbackData((prevState) => ({ ...prevState, ...formData }));
    reset({});
  };

  return (
    <>
      {isFeedBackFormLoading ? (
        <StyledLoaderWrapper>
          Loading... <Spinner />
        </StyledLoaderWrapper>
      ) : (
        <StyledFeedbackform onSubmit={handleSubmit(handlerSubmit)}>
          <StyledFormGroup>
            <Textarea
              name="message"
              label="Describe the bond you need:"
              placeholder="I need a __________ bond for the state of _______"
              isRequired
              control={control}
              rules={{
                required: "This field is required",
                validate: (value: string) => {
                  return value.trim().length || "The field could not be empty";
                },
              }}
            />
          </StyledFormGroup>
          <StyledFormGroup>
            <Input
              control={control}
              rules={{
                required: "This field is required",
                validate: (value: string) => {
                  const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                  return pattern.test(value) || "Incorrect email address";
                },
              }}
              isRequired
              icon="mail"
              iconSize={20}
              label="Enter your email and one of our agents will get back to you:"
              name="email"
            />
          </StyledFormGroup>
          <StyledFormGroup>
            <Input
              control={control}
              label="Phone (optional):"
              iconSize={20}
              icon="phone"
              name="phone"
            />
          </StyledFormGroup>
          <StyledFeedbackFormAction>
            {/* @ts-ignore */}
            <Button
              size="l"
              isBlock={isMobile}
              type="submit"
              isDisabled={Object.keys(errors).length > 0}
            >
              Submit
            </Button>
            <CSSTransition
              in={isShowedActionText}
              classNames="fadeInDown"
              timeout={800}
              unmountOnExit
            >
              <StyledActionText
                isError={feedBackFormError}
                isSuccess={feedBackFormSuccess}
              >
                {feedBackFormSuccess
                  ? "Message successfully sent!"
                  : feedBackFormError
                  ? "Error! Message not sent"
                  : ""}
              </StyledActionText>
            </CSSTransition>
          </StyledFeedbackFormAction>
        </StyledFeedbackform>
      )}
    </>
  );
};

export default FeedbackForm;
